import { entityTypes } from "@/src/constants/entityTypeConstants";

const MutationTypes = {
  SET_PAGE: "SET_PAGE",
  CLEAR_PAGE: "CLEAR_PAGE",
  RESET_STATE: "RESET_STATE",
};

const initialState = {
  [entityTypes.ACTION]: {
    page: null,
  },
};

const state = { ...initialState };

const mutations = {
  [MutationTypes.SET_PAGE](state, { entityType, page }) {
    state[entityType].page = page;
  },
  [MutationTypes.CLEAR_PAGE](state, { entityType }) {
    state[entityType].page = null;
  },
  [MutationTypes.RESET_STATE](state) {
    Object.assign(state, { ...initialState });
  },
};

const actions = {
  savePage({ commit }, { entityType, page }) {
    commit(MutationTypes.SET_PAGE, { entityType, page });
  },
  clearPage({ commit }, { entityType }) {
    commit(MutationTypes.CLEAR_PAGE, { entityType });
  },
  resetState({ commit }) {
    commit(MutationTypes.RESET_STATE);
  },
};

const getters = {
  getPageByType: (state) => (entityType) => {
    return state[entityType]?.page;
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
